import React from 'react';
import {Link,useLocation} from 'react-router-dom';
import {FiGlobe,FiTarget,FiArrowLeft,FiBookOpen,FiInfo} from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const Logo=()=> (
  <Link to="/" className="flex items-center gap-2 group">
    <div className="relative">
      <SafeIcon icon={FiTarget} className="text-3xl text-orange-600 rotate-12 transition-transform group-hover:rotate-0" />
      <div className="absolute -inset-1 bg-orange-600/20 blur rounded-full"></div>
    </div>
    <div className="flex flex-col leading-none">
      <span className="font-display text-2xl font-bold tracking-tighter text-white uppercase italic">
        barberadelvalles<span className="text-orange-500">.fit</span>
      </span>
    </div>
  </Link>
);

export default function TopNav({lang,setLang}) {
  const location=useLocation();
  const isSubPage=location.pathname !== '/' && !location.pathname.startsWith('/blog') && location.pathname !== '/about';
  
  const t={
    en: {
      backHome: "← Back to Home",
      blog: "Blog",
      about: "About"
    },
    es: {
      backHome: "← Volver al inicio",
      blog: "Blog",
      about: "Sobre mí"
    }
  }[lang];

  return (
    <header className="max-w-6xl mx-auto px-6 py-8 flex justify-between items-center relative z-50">
      <div className="flex items-center gap-8">
        {isSubPage ? (
          <Link 
            to="/" 
            className="flex items-center gap-2 text-orange-500 font-bold uppercase tracking-widest text-sm hover:text-white transition-colors"
          >
            <SafeIcon icon={FiArrowLeft} />
            {t.backHome}
          </Link>
        ) : (
          <>
            <Logo />
            <div className="hidden md:flex items-center gap-6">
              <Link 
                to="/blog" 
                className={`flex items-center gap-2 font-bold uppercase tracking-widest text-xs transition-colors ${location.pathname.startsWith('/blog') ? 'text-orange-500' : 'text-slate-400 hover:text-white'}`}
              >
                <SafeIcon icon={FiBookOpen} />
                {t.blog}
              </Link>
              <Link 
                to="/about" 
                className={`flex items-center gap-2 font-bold uppercase tracking-widest text-xs transition-colors ${location.pathname === '/about' ? 'text-orange-500' : 'text-slate-400 hover:text-white'}`}
              >
                <SafeIcon icon={FiInfo} />
                {t.about}
              </Link>
            </div>
          </>
        )}
      </div>

      <div className="flex items-center gap-4">
        <button 
          onClick={()=> setLang(lang==='en' ? 'es' : 'en')} 
          className="flex items-center gap-2 px-3 py-1.5 bg-slate-900/80 hover:bg-orange-600 transition-all rounded text-xs font-bold border border-slate-800"
        >
          <SafeIcon icon={FiGlobe} />
          {lang==='en' ? 'ES' : 'EN'}
        </button>
      </div>
    </header>
  );
}